import React from "react";
import { FormGroup, Input, CustomInput } from "reactstrap";
import moment from "moment";
import UploadImage from "./UploadImage";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    let first_categories = this.props.categories;
    const first_options = first_categories.map(category => (
      <option
        selected={
          this.props.data.first_category
            ? this.props.data.first_category.sort === category.sort
            : false
        }
        value={category.sort - 1}
      >
        {category.display_name}
      </option>
    ));

    let second_categories = this.props.second_categories;
    const second_options = second_categories.map(category => (
      <option
        selected={
          this.props.data.category_id
            ? this.props.data.category_id === category.id
            : false
        }
        value={category.id}
      >
        {category.display_name}
      </option>
    ));

    return (
      <div>
        <FormGroup>
          <label htmlFor="fisrtCategoryChange">一級分類</label>
          <Input
            id="fisrtCategoryChange"
            type="select"
            onChange={e => this.props.handleFisrtCategoryChange(e)}
          >
            {first_options}
          </Input>
        </FormGroup>

        <FormGroup>
          <label htmlFor="secondCategoryChange">二級分類</label>
          <Input
            id="secondCategoryChange"
            type="select"
            onChange={e => this.props.handleSecondCategoryChange(e)}
          >
            {second_options}
          </Input>
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={e => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>

        <div className="row">
          <div className="col-lg-6">
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example-text-input"
              >
                聯繫人
              </label>
              <Input
                id="example-text-input"
                type="text"
                value={this.props.data.contact}
                onChange={e => this.props.onTextInputChange(e, "contact")}
              />
            </FormGroup>
          </div>
          <div className="col-lg-6">
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example-text-input"
              >
                電話
              </label>
              <Input
                id="example-text-input"
                type="text"
                value={this.props.data.phone}
                onChange={e => this.props.onTextInputChange(e, "phone")}
              />
            </FormGroup>
          </div>
          <div className="col-lg-6">
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example-text-input"
              >
                郵箱（選填）
              </label>
              <Input
                id="example-text-input"
                type="text"
                value={this.props.data.email}
                onChange={e => this.props.onTextInputChange(e, "email")}
              />
            </FormGroup>
          </div>
          <div className="col-lg-6">
            <FormGroup>
              <label
                className="form-control-label"
                htmlFor="example-text-input"
              >
                網站連結（選填）
              </label>
              <Input
                id="example-text-input"
                type="text"
                value={this.props.data.website}
                onChange={e => this.props.onTextInputChange(e, "website")}
              />
            </FormGroup>
          </div>
        </div>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            地址
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.address}
            onChange={e => this.props.onTextInputChange(e, "address")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            簡介
          </label>
          <Input
            id="example-text-input"
            type="textarea"
            value={this.props.data.body}
            onChange={e => this.props.onTextInputChange(e, "body")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type="checkbox"
            id="is_promoted"
            name="is_promoted"
            label="是否推薦"
            checked={this.props.data.is_promoted}
            onChange={e =>
              this.props.onTextInputChange(
                { target: { value: e.target.checked } },
                "is_promoted"
              )
            }
          />
        </FormGroup>
        {this.props.data.is_promoted ? (
          <FormGroup>
            <label className="form-control-label">
              推薦图片（可選，留空則視為與封面圖片相同）
            </label>
            <UploadImage
              onChange={file => {
                console.log("file", file);
                this.props.onTextInputChange(
                  { target: { value: file } },
                  "promo_image_file"
                );
              }}
              src={this.props.data.promo_image}
            />
          </FormGroup>
        ) : null}
      </div>
    );
  }
}

export default ArticleForm;
